module.exports = __webpack_public_path__ + "img/Icekredit_logo.082e86f0.png";